import { Component, OnInit } from '@angular/core';
import { ParticipationDataService } from '../_services/participation-data.service';
import { ActivatedRoute } from '@angular/router';
import { CustomErrorsHandlerService } from '../_services/custom-errors-handler.service';
import { PrintRequest, ScannerRequest } from '../common-class/print-request';
import { EncryptionAndDecryption } from '../COMMON-LOGIC/EncryptionAndDecryption';
import { environment } from 'src/environments/environment';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-print-response',
  templateUrl: './print-response.component.html',
  styleUrls: ['./print-response.component.css'],
})
export class PrintResponseComponent implements OnInit {
  urlParam: string;
  printBody: string;
  arrData: string;
  downloadMessage: string;
  ToasterMessage: string[];
  categoryScoreGraphJson: string[];
  printRequest: PrintRequest;
  scannerRequest: ScannerRequest;
  showLoader = false;
  isToasterVisible = false;
  hasBeenVisible = false;
  showPrintdiv = false;
  isK12 = false;
  productName = '';
  productTitle = '';
  removeBranding = false;

  constructor(
    public service: ParticipationDataService,
    private activatedRoute: ActivatedRoute,
    private errorsHandlerService: CustomErrorsHandlerService,
  ) {}

  ngOnInit(): void {
   
    this.showPrintdiv = false;
    this.productTitle = environment.productName;
    if (this.productTitle == 'K12 Insight') {
      this.isK12 = true;
      this.productName = 'k12';
    }
    document.body.classList.add('PMRBody');
    this.GetUrlData();
    if (this.removeBranding) {
      const head = document.getElementsByTagName('head')[0];
      const link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = 'faviconempty.ico';
      head.appendChild(link);
    }
    let url = '';
    if (
      this.printRequest != undefined &&
      this.printRequest != null &&
      this.printRequest.format != undefined &&
      (this.printRequest.format.toUpperCase() == 'PDF' ||
        this.printRequest.format.toUpperCase() == 'WORD')
    ) {
      url = 'surveyPrintDownload';
      this.showPrintdiv = false;
      this.service
        .postPrintData(
          url,
          JSON.stringify(
            EncryptionAndDecryption.EncryptionData(
              '123456$#@$^@1ERF',
              JSON.stringify(this.printRequest),
            ),
          ),
        )
        .subscribe(
          (resultBlob) => {
            const contentDisposition = resultBlob.headers.get('content-disposition') || '';
            const fileNameRegex = /(?:filename\*?=['"]?)([^;\n"']*)['"]?/;
            const matches = fileNameRegex.exec(contentDisposition);
            const fileName = (matches && matches[1]) ? decodeURIComponent(matches[1]) : 'untitled';            
            const fileNameModified = fileName.replace(/^(_+)|(_+)$/g, '').trim(); // Remove any leading/trailing underscores
            if (!this.printRequest.isFromAllProjectDashboard) {
              const downloadLink = document.createElement('a');
              downloadLink.download = fileNameModified;  // Use the modified file name
              downloadLink.href = URL.createObjectURL(resultBlob.body);
              downloadLink.click();
            }
          },
          (error) => {
            this.errorsHandlerService.handleError(error);
            if (error.name == 'HttpErrorResponse') {
              window.location.replace('../survey/sd?err=1&ng=2&cn=' + this.printRequest.corpNo);
            }
          },
        );
    } else if (
      this.printRequest != undefined &&
      this.printRequest != null &&
      (this.printRequest.format == undefined || this.printRequest.format == '')
    ) {
      this.showLoader = true;
      url = 'surveyPrintShow';
      this.service
        .postDataUsingPromise(
          url,
          JSON.stringify(
            EncryptionAndDecryption.EncryptionData(
              '123456$#@$^@1ERF',
              JSON.stringify(this.printRequest),
            ),
          ),
        )
        .then(
          async (data) => {
            this.arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
            if (this.arrData.includes('$###$')) {
              this.categoryScoreGraphJson = this.arrData.split('$###$');
              this.ToasterMessage = this.categoryScoreGraphJson[0].split('#$$$#');
              this.printBody = this.ToasterMessage[0] + this.ToasterMessage[2];
              this.downloadMessage = this.ToasterMessage[1];
              setTimeout(() => {
                this.displayCategoryGraph(this.categoryScoreGraphJson[1]);
              }, 200);
            } else {
              this.ToasterMessage = this.arrData.split('#$$$#');
              this.printBody = this.ToasterMessage[0] + this.ToasterMessage[2];
              this.downloadMessage = this.ToasterMessage[1];
            }
            this.showPrintdiv = true;
            setTimeout(() => {
              this.showLoader = false;
            }, 1000);
          },
          (error) => {
            this.errorsHandlerService.handleError(error);
            if (error.name == 'HttpErrorResponse') {
              window.location.replace('../survey/sd?err=1&ng=2&cn=' + this.printRequest.corpNo);
            }
          },
        );
    } else if (this.scannerRequest != undefined && this.scannerRequest != null) {
      url = 'scannerReadyDownLoad';
      this.showPrintdiv = false;
      this.service
        .postPrintData(
          url,
          JSON.stringify(
            EncryptionAndDecryption.EncryptionData(
              '123456$#@$^@1ERF',
              JSON.stringify(this.scannerRequest),
            ),
          ),
        )
        .subscribe(
          (resultBlob) => {
            const contentDisposition = resultBlob.headers.get('content-disposition') || '';
            const fileNameRegex = /(?:filename\*?=['"]?)([^;\n"']*)['"]?/;
            const matches = fileNameRegex.exec(contentDisposition);
            const fileName = (matches && matches[1]) ? decodeURIComponent(matches[1]) : 'untitled';            
            const fileNameModified = fileName.replace(/^(_+)|(_+)$/g, '').trim(); // Remove any leading/trailing underscores
            if (!this.scannerRequest.isFromAllProjectDashboard) {
              const downloadLink = document.createElement('a');
              downloadLink.download = fileNameModified;  // Use the modified file name
              downloadLink.href = URL.createObjectURL(resultBlob.body);
              downloadLink.click();
            }
          },
          (error) => {
            this.errorsHandlerService.handleError(error);
            if (error.name == 'HttpErrorResponse') {
              window.location.replace('../survey/sd?err=1&ng=2&cn=' + this.printRequest.corpNo);
            }
          },
        );
    }
  }

  downloadSurvey() {
    this.isToasterVisible = true;
    this.hasBeenVisible = true;
    this.showLoader = true;
    let url = '';
    this.printRequest.format = 'pdf';
    if (
      this.printRequest.format != undefined &&
      (this.printRequest.format.toUpperCase() == 'PDF' ||
        this.printRequest.format.toUpperCase() == 'WORD')
    ) {
      setTimeout(() => {
        this.isToasterVisible = false;
      }, 10000);
      url = 'surveyPrintDownload';
      this.service
        .postPrintData(
          url,
          JSON.stringify(
            EncryptionAndDecryption.EncryptionData(
              '123456$#@$^@1ERF',
              JSON.stringify(this.printRequest),
            ),
          ),
        )
        .subscribe(
          (resultBlob) => {
            setTimeout(() => {
              this.showLoader = false;
              this.isToasterVisible = false;
            }, 250);
            const contentDisposition = resultBlob.headers.get('content-disposition') || '';
            const fileNameRegex = /(?:filename\*?=['"]?)([^;\n"']*)['"]?/;
            const matches = fileNameRegex.exec(contentDisposition);
            const fileName = (matches && matches[1]) ? decodeURIComponent(matches[1]) : 'untitled';            
            const fileNameModified = fileName.replace(/^(_+)|(_+)$/g, '').trim(); // Remove any leading/trailing underscores
            const downloadLink = document.createElement('a');
            downloadLink.download = fileNameModified;  // Use the modified file name
            downloadLink.href = URL.createObjectURL(resultBlob.body);
            downloadLink.click();
          },
          (error) => {
            this.errorsHandlerService.handleError(error);
            this.showLoader = false;
            if (error.name == 'HttpErrorResponse') {
              window.location.replace('../survey/sd?err=1&ng=2&cn=' + this.printRequest.corpNo);
            }
          },
        );
    }
  }

  closeToaster() {
    this.isToasterVisible = false;
  }

  Decryption(strEncrypted: string): string {
    try {
      let i: number;
      let strOLD = '';
      strEncrypted = strEncrypted.trim();
      strEncrypted = strEncrypted.substring(4);
      strEncrypted = strEncrypted.slice(0, -3);
      const strrowkeys = strEncrypted.split('z');
      const strval = strrowkeys[0];
      for (i = 0; i <= strval.length - 1; i++) {
        strOLD += strval.charCodeAt(i) - 99;
      }
      strOLD = strOLD.split('').reverse().join('');

      return strOLD;
    } catch {
      return '';
    }
  }

  GetUrlData(): any {
    let strUid = '';
    let strintLang = '';
    let intLang = 0;
    let strintCorpNo = '';
    let intCorpNo = 0;
    let strintSurveyNo = '';
    let intSurveyNo = 0;
    let strintRecNo = '';
    let intRecNo = 0;
    let strformat = '';
    let intTrackID = 0;
    let email = '';
    let pgno = '';
    let resptype = '';
    let strDir = '';
    let removeBrand = "False";
    let isResultOnly = false;
    let isFromAllProjectDashboard = '0';
    this.activatedRoute.queryParams.subscribe(async (params) => {
      email = params['email'] == '' || params['email'] == undefined ? 'false' : params['email'];
      isFromAllProjectDashboard = params['isFromAllProjectDashboard'] == '' || params['isFromAllProjectDashboard'] == undefined ? '0' : params['isFromAllProjectDashboard'];
      strformat = params['format'] == '' || params['format'] == undefined ? '' : params['format'];
      intTrackID =
        params['trackId'] == '' || params['trackId'] == undefined ? '' : params['trackId'];
      pgno = params['pgno'] == '' || params['pgno'] == undefined ? '' : params['pgno'];
      resptype =
        params['resptype'] == '' || params['resptype'] == undefined ? '' : params['resptype'];
      strDir = params['strDir'] == '' || params['strDir'] == undefined ? '' : params['strDir'];
      removeBrand = params['removeBrand'] == '' || params['removeBrand'] == undefined ? 0 : params['removeBrand'];
      isResultOnly =
        params['isResultOnly'] == '' || params['isResultOnly'] == undefined
          ? false
          : params['isResultOnly'] == '1'
            ? true
            : false;
      if (params['UID'] == null) strUid = '1234';
      else strUid = params['UID'];

      this.removeBranding = removeBrand == "False" ? false : true;
      // Parameter Decoding Logic and additional Error Handling
      if (params['lang'] != '') {
        if (strformat != 'scanner')
          strintLang = this.Decryption(params['lang']).toString().replace("'", "''");
        else strintLang = params['lang'];

        if (parseInt(strintLang) >= -2147483647 && parseInt(strintLang) <= 2147483647)
          intLang = parseInt(strintLang);
        else this.printBody = ' 1 Invalid URL!!';
      }
      if (params['cno'] != undefined && params['cno'].trim() != '') {
        strintCorpNo = this.Decryption(params['cno']).replace("'", "''");
        if (parseInt(strintCorpNo) >= -2147483647 && parseInt(strintCorpNo) <= 2147483647)
          intCorpNo = parseInt(strintCorpNo);
        else this.printBody = '2 Invalid URL!!';
      }
      if (params['CorpNo'] != undefined && params['CorpNo'].trim() != '') {
        strintCorpNo = params['CorpNo'];
        if (parseInt(strintCorpNo) >= -2147483647 && parseInt(strintCorpNo) <= 2147483647)
          intCorpNo = parseInt(strintCorpNo);
        else this.printBody = '3 Invalid URL!!';
      }
      if (params['sid'] != undefined && params['sid'].trim() != '') {
        strintSurveyNo = this.Decryption(params['sid']).replace("'", "''");
        if (parseInt(strintSurveyNo) >= -2147483647 && parseInt(strintSurveyNo) <= 2147483647)
          intSurveyNo = parseInt(strintSurveyNo);
        else this.printBody = ' 4 Invalid URL!!';
      }
      if (params['SurveyNo'] != undefined && params['SurveyNo'].trim() != '') {
        strintSurveyNo = params['SurveyNo'];
        if (parseInt(strintSurveyNo) >= -2147483647 && parseInt(strintSurveyNo) <= 2147483647)
          intSurveyNo = parseInt(strintSurveyNo);
        else this.printBody = '6 Invalid URL!!';
      }
      if (params['recno'] != undefined && params['recno'].trim() != '') {
        if (strformat != 'scanner')
          strintRecNo = this.Decryption(params['recno']).replace("'", "''");
        else strintRecNo = params['recno'];

        if (parseInt(strintRecNo) >= -2147483647 && parseInt(strintRecNo) <= 2147483647)
          intRecNo = parseInt(strintRecNo);
        else this.printBody = '7 Invalid URL!!';
      }
      // Validations To Avoid URL Manipulation
      if (intLang.toString() != '')
        this.printBody = '8 Invalid URL!!';

      if (intCorpNo.toString() != '') this.printBody = '12 Invalid URL!!';

      if (intSurveyNo.toString() != '') this.printBody = '9 Invalid URL!!';
      if (strUid != '' && params['UID'] != null && isNaN(params['UID']))
        this.printBody = '10 Invalid URL!!';
      if (
        !(
          strformat.trim() == '' ||
          strformat.toUpperCase() == 'WORD' ||
          strformat.toUpperCase() == 'PDF' ||
          strformat.toUpperCase() == 'SCANNER'
        )
      )
        this.printBody = ' 11 Invalid URL!!';
    });
    if (strformat.toUpperCase() == 'SCANNER') {
      this.scannerRequest = new ScannerRequest();
      this.scannerRequest.CorpNo = intCorpNo;
      this.scannerRequest.Lang = intLang;
      this.scannerRequest.SurveyNo = intSurveyNo;
      this.scannerRequest.isFromAllProjectDashboard = isFromAllProjectDashboard == '1';
    } else {
      this.printRequest = new PrintRequest();
      this.printRequest.corpNo = intCorpNo.toString();
      this.printRequest.email = email;
      if (sessionStorage.getItem('CatGraph_' + intRecNo)) {
        this.printRequest.base64Img = sessionStorage.getItem('CatGraph_' + intRecNo);
      } else {
        this.printRequest.base64Img = '';
      }
      this.printRequest.format = strformat;
      this.printRequest.isNew = 'false';
      this.printRequest.isResultOnly = isResultOnly;
      this.printRequest.isPBSDonwload = false;
      this.printRequest.lang = intLang.toString();
      this.printRequest.langname = '';
      this.printRequest.multi = 'false';
      this.printRequest.page = '';
      this.printRequest.pageno = pgno;
      this.printRequest.pdfLastPage = '';
      this.printRequest.pdftopage = '';
      this.printRequest.pgno = pgno;
      this.printRequest.recno = intRecNo.toString();
      this.printRequest.resptype = resptype;
      this.printRequest.strDir = strDir;
      this.printRequest.Sid = intSurveyNo.toString();
      this.printRequest.trackId = intTrackID.toString();
      this.printRequest.type = '';
      this.printRequest.strAngularHost = window.location.protocol + '//' + window.location.host;
      this.printRequest.isFromAllProjectDashboard = isFromAllProjectDashboard == '1';
      const peintresponseEnc = localStorage.getItem(
        EncryptionAndDecryption.EncryptionData('123456$#@$^@1ERF', intRecNo.toString()),
      );
      if (peintresponseEnc && peintresponseEnc.length > 0) {
        this.printRequest.participationResponseData = JSON.parse(
          EncryptionAndDecryption.DecryptionData(
            '123456$#@$^@1ERF',
            peintresponseEnc.replace(/^"(.*)"$/, '$1'),
          ),
        );
      }
    }
  }

  displayCategoryGraph(jsonData: string): void {
    const parsedData = JSON.parse(jsonData);
    const categories = [];
    const categoryScoresPercentage = [];
    const avgScoresPercentage = [];
    parsedData.forEach((element) => {
      categories.push(element.CategoryName);
      categoryScoresPercentage.push(element.PercentageEarned);
      avgScoresPercentage.push(element.AvgScorePercent);
    });
    const seriesForCategoryScoreGraph = [
      {
        name: 'Category Score',
        data: categoryScoresPercentage,
        type: 'bar',
        color: '#7CB5EC',
        pointWidth: 12,
      },
    ];
    this.displayGraph(categories, seriesForCategoryScoreGraph);
  }

  displayGraph(categories: any, categoriesseries: any): void {
    let rotation;
    let tickInterval;
    const minHeight = 200;
    const categoryCount = categories.length;

    const dvCatGraph = document.getElementById('dv_CatGraph'); 
    if (dvCatGraph) { // Check if the element exists
      if (categoriesseries.length == 1) {
        dvCatGraph.style.height = `${minHeight + categoryCount * (parseInt(categoriesseries[0].pointWidth) + 5)}px`;
      } else {
        dvCatGraph.style.height = `${minHeight + categoryCount * (parseInt(categoriesseries[0].pointWidth) + 20)}px`;
      }
    }
    let min = 0;
    let max = 100;
    max = Math.max(...categoriesseries[0].data);
    min = Math.min(...categoriesseries[0].data);
    if (categoriesseries.length === 2) {
      if (Math.max(...categoriesseries[1].data) > max) max = Math.max(...categoriesseries[1].data);
      if (Math.min(...categoriesseries[1].data) < min) min = Math.min(...categoriesseries[1].data);
    }
    if (min > 0) min = 0;
    if (max > 0) max = 100;
    if (min < 0 && max <= 0) min = -100;
    if (max < 0) max = 0;
    rotation = 0;
    tickInterval = 20;
    Highcharts.chart('dv_CatGraph', {
      chart: {
        type: 'bar',
        alignTicks: false,
      },
      title: {
        text: '',
      },
      exporting: {
        enabled: false,
      },
      xAxis: {
        labels: {
          step: 1,
        },
        categories: categories,
        title: {
          text: null,
          style: {
            fontSize: '12px',
            fontWeight: '400',
            fontFamily: 'Proxima N W01 Smbd',
          },
        },
      },
      yAxis: {
        min: min,
        minRange: 20,
        max: max === 0 ? null : max,
        tickInterval: tickInterval,
        title: {
          text: null,
          align: 'high',
          style: {
            fontSize: '12px',
            fontWeight: '400 !important',
            fontFamily: 'Proxima N W01 Smbd !important',
          },
        },
        labels: {
          overflow: 'justify',
          style: {
            fontSize: '12px',
            fontWeight: '400 !important',
            fontFamily: 'Proxima N W01 Smbd !important',
          },
          rotation: rotation,
        },
      },
      tooltip: {
        valueSuffix: ' %',
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            crop: false,
            allowOverlap: true,
            style: {
              fontSize: '12px',
              fontWeight: '600 !important',
              fontFamily: 'Proxima N W01 Smbd !important',
            },
            format: '{y} %',
          },
        },
        series: {
          events: {
            legendItemClick: function (e) {
              e.preventDefault();
            },
          },
        },
      },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        x: 0,
        y: 0,
        itemStyle: {
          cursor: 'default',
        },
      },
      credits: {
        enabled: false,
      },
      series: categoriesseries,
    });
  }
}
